// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.swiftref-radio-button-label {
    margin-bottom: var(--spacing-10);
    height: 20px;
    display: flex;
    align-items: center;
    color: var(--text-default);
    width: max-content;
    font-family: var(--font-family);
    gap: var(--spacing-10);
    position: relative;
    user-select: none;
    /*margin-bottom: var(--spacing-10);*/
}
:host([disabled]) .swiftref-radio-button-label {
    color: var(--text-disabled);
}
fieldset {
    border: none;
    margin: 0;
    padding: 0;
}

/*!*custom checkbox see https://developer.mozilla.org/en-US/docs/Learn/Forms/Advanced_form_styling*!*/
.swiftref-radio-button {
    height: var(--spacing-20);
    width: var(--spacing-20);
    margin: 0;
    padding: 0;
    appearance: none;
    border: var(--border-weight-default) solid var(--border-strong);
    border-radius: 50%;
}
.swiftref-radio-button:not(:disabled) {
    cursor: pointer;
}
.swiftref-radio-button:disabled {
    cursor: not-allowed;
}


.swiftref-radio-button::before {
    /*font-size: 1.2em;*/
    /*right: 0;*/
    /*top: 0;*/
    /*visibility: hidden;*/
}
.swiftref-radio-button:checked::after {
    content: "";
    position: absolute;
    left: 4px;
    top: 6px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--accent-strong-selected);
}

.swiftref-radio-button:checked {
    background: var(--accent-light-selected);
}
.swiftref-radio-button:hover  {
    background: var(--accent-light-hover);
}
.swiftref-radio-button:focus  {
    /*style guides says 2px*/
    border: var(--border-weight-default) solid var(--border-focused);
}
.swiftref-radio-button:disabled  {
    background: var(--background-disabled);
}



.swiftref-radio-button:checked:disabled::after {
    background: var(--icon-disabled);
}

.swiftref-radio-button:checked::after {
    visibility: visible;
    color: var(--accent-strong-selected);
}
`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/form/radio/style/index.css"],"names":[],"mappings":";AACA;IACI,gCAAgC;IAChC,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,+BAA+B;IAC/B,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,oCAAoC;AACxC;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,YAAY;IACZ,SAAS;IACT,UAAU;AACd;;AAEA,qGAAqG;AACrG;IACI,yBAAyB;IACzB,wBAAwB;IACxB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,+DAA+D;IAC/D,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;;;AAGA;IACI,oBAAoB;IACpB,YAAY;IACZ,UAAU;IACV,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,wCAAwC;AAC5C;AACA;IACI,qCAAqC;AACzC;AACA;IACI,wBAAwB;IACxB,gEAAgE;AACpE;AACA;IACI,sCAAsC;AAC1C;;;;AAIA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,oCAAoC;AACxC","sourcesContent":["\n.swiftref-radio-button-label {\n    margin-bottom: var(--spacing-10);\n    height: 20px;\n    display: flex;\n    align-items: center;\n    color: var(--text-default);\n    width: max-content;\n    font-family: var(--font-family);\n    gap: var(--spacing-10);\n    position: relative;\n    user-select: none;\n    /*margin-bottom: var(--spacing-10);*/\n}\n:host([disabled]) .swiftref-radio-button-label {\n    color: var(--text-disabled);\n}\nfieldset {\n    border: none;\n    margin: 0;\n    padding: 0;\n}\n\n/*!*custom checkbox see https://developer.mozilla.org/en-US/docs/Learn/Forms/Advanced_form_styling*!*/\n.swiftref-radio-button {\n    height: var(--spacing-20);\n    width: var(--spacing-20);\n    margin: 0;\n    padding: 0;\n    appearance: none;\n    border: var(--border-weight-default) solid var(--border-strong);\n    border-radius: 50%;\n}\n.swiftref-radio-button:not(:disabled) {\n    cursor: pointer;\n}\n.swiftref-radio-button:disabled {\n    cursor: not-allowed;\n}\n\n\n.swiftref-radio-button::before {\n    /*font-size: 1.2em;*/\n    /*right: 0;*/\n    /*top: 0;*/\n    /*visibility: hidden;*/\n}\n.swiftref-radio-button:checked::after {\n    content: \"\";\n    position: absolute;\n    left: 4px;\n    top: 6px;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: var(--accent-strong-selected);\n}\n\n.swiftref-radio-button:checked {\n    background: var(--accent-light-selected);\n}\n.swiftref-radio-button:hover  {\n    background: var(--accent-light-hover);\n}\n.swiftref-radio-button:focus  {\n    /*style guides says 2px*/\n    border: var(--border-weight-default) solid var(--border-focused);\n}\n.swiftref-radio-button:disabled  {\n    background: var(--background-disabled);\n}\n\n\n\n.swiftref-radio-button:checked:disabled::after {\n    background: var(--icon-disabled);\n}\n\n.swiftref-radio-button:checked::after {\n    visibility: visible;\n    color: var(--accent-strong-selected);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
